import { ReactNode, createContext } from 'react';

interface ErrorBoundaryContextProps {
  fallback: ReactNode;
}

export const ErrorBoundaryContext = createContext<ErrorBoundaryContextProps>({
  fallback: null,
});
